import React from 'react'
import ProdWastageRow from './ProdWastageRow'
import withView from '../../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import { UiView, UiViewContent } from "../../../../../library/layout/Index";

const ProdWastage = (props) => {
    const { formObject, viewData } = props;

    return (
        <>
            <UiView>
                <UiViewContent>
                    <ul className="uiListTable uiProductionTable uiRawDataView uiSpacer20" style={{ minWidth: "1450px" }}>
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnLeft uiColumn130"><SarasTrans value="Item Id" /></li>
                                <li className="uiColumnLeft uiColumn350"><SarasTrans value="Item Name" /></li>
                                <li className="uiColumnLeft uiColumn50"><SarasTrans value="Unit" /></li>
                                <li className="uiColumnRight uiColumnQty"><SarasTrans value="Issued" /></li>
                                <li className="uiColumnRight uiColumnQty"><SarasTrans value="Wasted" /></li>
                                <li className="uiColumnRight uiColumnQty"><SarasTrans value="Damaged" /></li>
                                <li className="uiColumnRight uiColumnQty"><SarasTrans value="Lost" /></li>
                                <li className="uiColumnRight uiColumnQty"><SarasTrans value="% Allow" /></li>
                                <li className="uiColumnRight uiColumnQty"><SarasTrans value="Allowed" /></li>
                                <li className="uiColumnRight uiColumnQty"><SarasTrans value="Diff" /></li>
                                <li className="uiColumnRight uiColumnQty"><SarasTrans value="% Loss" /></li>
                                <li className="uiColumnRight uiColumnQty"><SarasTrans value="% Diff" /></li>
                                <li className="uiColumnRight uiColumn70"><SarasTrans value="Wastage Value" /></li>
                                <li className="uiColumnRight uiColumn70"><SarasTrans value="Deduction" /></li>
                                <li className="uiColumnLeft uiColumn150"><SarasTrans value="Remark" /></li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData.viewRows : {}).map((row, index) => (
                                <li><ProdWastageRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1} /></li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        </>
    )
}

export default withView(ProdWastage, "prodWaste", "");
